import sleep from './sleep';
export default async (action, failureHandler, maxTrial = 10, delay = 1000) => {
    let trial = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        if (++trial > maxTrial) {
            failureHandler();
            break;
        }
        const toStop = await action();
        if (toStop) {
            break;
        }
        await sleep(delay);
    }
};
